// The receiving end of a trade: someone is holding something out to you.
//
// Consent has to be a real, visible act — the server will not move units
// without it — so this is a prompt you answer, never a thing that happens
// to you while you are looking the other way.

import type { TradeRequestMessage, TradeResultMessage } from "@bebop/shared";
import { escapeHtml } from "./escape";

export class TradePrompt {
  private root: HTMLDivElement;
  private pending: string | undefined;

  constructor(
    parent: HTMLElement,
    private respond: (offerId: string, accept: boolean) => void,
  ) {
    this.root = document.createElement("div");
    this.root.className = "trade-prompt";
    this.root.style.display = "none";
    parent.append(this.root);
  }

  show(request: TradeRequestMessage): void {
    this.pending = request.offerId;
    this.root.innerHTML = `
      <div class="trade-line">
        <strong>${escapeHtml(request.fromName)}</strong> offers you
        <span class="trade-what">${escapeHtml(request.what)}</span>
      </div>
      <div class="trade-actions">
        <button class="trade-take">take it</button>
        <button class="trade-pass">no thanks</button>
      </div>
    `;
    this.root.style.display = "";
    (this.root.querySelector(".trade-take") as HTMLButtonElement).addEventListener("click", () =>
      this.answer(true),
    );
    (this.root.querySelector(".trade-pass") as HTMLButtonElement).addEventListener("click", () =>
      this.answer(false),
    );
  }

  /** The outcome line, from either side of the exchange. */
  showResult(result: TradeResultMessage): void {
    this.root.innerHTML = `<div class="trade-line ${result.ok ? "good" : "bad"}">${escapeHtml(result.message)}</div>`;
    this.root.style.display = "";
    window.setTimeout(() => {
      if (!this.pending) this.root.style.display = "none";
    }, 3500);
  }

  private answer(accept: boolean): void {
    if (!this.pending) return;
    this.respond(this.pending, accept);
    this.pending = undefined;
    this.root.style.display = "none";
  }
}
